import { configureStore } from '@reduxjs/toolkit';
import { StoreKeys } from '@/configs/StoreKeys';
import appReducer from './slices/appSlice';
import componentFormReducer from './slices/componentFormSlice';

export const store = configureStore({
	reducer: {
		[StoreKeys.app]: appReducer,
		[StoreKeys.componentForm]: componentFormReducer,
	},
	devTools: import.meta.env.DEV,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
